/**
 * consists all the api mapping (routes)
 */
export const APIMapping = {
  GET_PROJECTS: 'projects/:id',
  CREATE_PROJECT:'projects',
  EDIT_PROJECT: 'projects',
  DELETE_PROJECT: 'projects/:id',
  COPY_PROJECT: 'copyProject',
  ADD_PROJECT_LOGO:'projectLogo',
  EDIT_PROJECT_LOGO: 'projectLogo',
  ADD_APPLICATION_LOGO:'applicationLogo',
  GET_APPLICATIONS:'applications/:id',
  GET_APPLICATION:'application/:id',
  CREATE_APPLICATION:'application',
  EDIT_APPLICATION:'application',
  EDIT_APPLICATION_LOGO:'applicationLogo',
  UPDATE_APPLICATION_MEDIA:'applicationLogo/update',
  EDIT_THEME:'themes',
  GET_THEME_BYID:'themes/:id',
  GET_PAGES: 'pages/:application_id',
  CREATE_OR_UPDATE_PAGE : 'pages',
  COPY_PAGE : 'page/copyPage',
  GET_PAGE : 'page/:page_id',
  DELETE_PAGE : 'page/:page_id/:force_delete',
  CREATE_OR_UPDATE_FORM: 'forms',
  DELETE_FORM : 'form/:form_id',
  CREATE_OR_EDIT_WIDGET: 'widgets',
  DELETE_WIDGET: 'widgets/:widget_id',
  GET_MASTER_PAGES: 'masterPages/:application_type_id',
  GET_DEFAULT_PAGES: 'defaultPages',
  PUBLISH_APP:'publish',
  ENABLE_PUBLISH:'enablePublish',
  CREATE_MASTER_PAGES:'defaultPages',
  GET_THEMES: 'themes',
  GET_ENTITIES_OR_ATTRIBUTES: 'entity/list',
  CREATE_OR_UPDATE_DATALIST_VIEWPAGE: 'datalistDisaplayViewPage',
  UPDATE_ENTITY: 'entity',
  DELETE_ENTITY: 'entity/deletion',
  FETCH_PREVIEW: 'preview',
  DELETE_PREVIEW: 'preview/:applicationId/:previewPageId/:widgetId',
  GET_APK_DETAILS: 'applicationURL/details',
  GET_METRICS:'metrics',
  GET_ENTITY_SUBMISSION_DATA: 'entitySubmissions/downloadExcel',
  WIDGET_REARRANGE: 'webForms/updation',
  GET_MOB_AND_WEB_ENTITIES: 'BuilderEntity/list',
  GET_ENTITY_SUBMISSIONS_DATA: 'BuilderEntitySubmissions/list',
  CREATE_THEME: 'themes',
  MOBILE_LOGIN:'mobile-login',
  DISABLE_USER:'disableUser/:id',
  GET_APPLICATION_TYPES: 'applicationTypes',
  CHECK_APPLICATION_NAME:'application/name/:application_name',
  CREATE_CUSTOM_API:'api/create',
  UPDATE_CUSTOM_API:'api/update',
  GET_ALL_APIS:'apis/list',
  GET_API:'api/:api_id',
  DELETE_API:'apis/delete',
  ADD_OR_UPDATE_WIDGET_IMAGE:'uploadFile',
  SOCIAL_LOGIN: 'social-login',
  PLAYSTORE_CERTIFICATE:'playstoreCertificate',
  PLAYSTORE_CERTIFICATE_LIST:'playstoreCertificate/list',
  WEB_APP_URL:'applicationURL/:application_id',
  FETCH_ROLES: 'roles/user/:user_id',
  WORKFLOW_CREATE_UPDATE: 'workflow',
  WORKFLOW_DELETE: 'workflow/:workflow_id',
  WORKFLOW_FETCH: 'workflow/:fetch_type/:fetch_id',
  STAGE_CREATE_UPDATE: 'stage',
  STAGE_DELETE: 'stage/:stage_id',
  STAGE_FETCH: 'stage/:fetch_type/:fetch_id',
  PRIVACY_POLICY_ADD_OR_EDIT:'privacypolicy',
  PRIVACY_POLICY_GET:'getprivacypolicy/:applicationId',
  FETCH_POLICY_BY_APPLICATIONID:'getprivacypolicy/:applicationId',
  RESET_PRIVACY_POLICY:'privacypolicy/resetpolicy',
  UPLOAD_FILE:'uploadCsv',
  UPLOAD_ENTITY_DATA:'UploadCsvData',
  FETCH_ENTITY_ENTRIES:'enitiyFormSubmissions/list',
  EDIT_ENTITY_ENTRY:'entitySubmissions/updation',
  DELETE_ENTITY_ENTRY:'deleteSubmission',

  //media (resource mobilebuilde)
  GET_MEDIA_IMAGES:'resourceImage/:application_id',
  UPLOAD_MEDIA_IMAGE:'resourceImage',
  REPLACE_MEDIA_IMAGE:'resourceImage/update',
  DELETE_MEDIA_IMAGE:'resourceImage/delete',
  CHECK_REPLACE_MEDIA_LINKS:'resourceImage/check',

  // customer specific extra fiels
  FETCH_ADDITIONAL_USERFORM_FIELDS:'extra-fileds/:REPLACE_CUSTOMER_ID',

  // API module
  GET_CUSTOM_API_RESPONSE:'apis/request',

  // stream api
  STREAM_API: 'stream-file',

  //migrate project
  MIGRATE_PROJECT: 'migrateProject/project',
  FETCH_DIFFERENT_ENV_PROJECTS:'migrateProject/project/list'
}
